import React, { Component } from 'react';
import { Button, Tooltip, Pagination, Select, Row, Col, Checkbox } from 'antd';
import saveItemMaster from './../../../../../resources/assets/images/save_item_master.png'

const { Option } = Select

class ToolbarItemProhibited extends Component {
    onChangeHasApprove = (e) => {
        let value = e.target.checked;
        this.props.onChangeHasApprove(value);
    }

    renderProhibitedModel = (ProhibitedModel) => {
        if (ProhibitedModel) {
            return ProhibitedModel.map((item) => (
                <a className={this.props.keywordSearch === item.ProhibitedKeyWord ? "active-filter-prohibited prohibited-word" : "prohibited-word"}
                    onClick={e => this.handleFilterProhibited(item.ProhibitedKeyWord)}>{`${item.ProhibitedKeyWord}(${item.Number})`}</a>
            ))
        }
        return null
    }

    handleFilterProhibited = (keyword) => {
        this.props.onChangeKeywordSearch(keyword)
    }

    render() {
        return (
            <React.Fragment>
                <div className="prohibited-options">
                    <Row gutter={6}>
                        <Col span={12}>
                            <span className="icon-save-file">
                                <Tooltip placement="top" title="Save Item">
                                    <Button
                                        onClick={() => this.props.saveItemName()}
                                        disabled={!this.props.isEdit}
                                    >
                                        <img id='save-item-master' src={saveItemMaster} style={!this.props.isEdit ? { opacity: '0.5' } : null} />
                                    </Button>
                                </Tooltip>
                            </span>
                        </Col>
                        <Col span={12}>
                            <div className="table-header-right">
                                {this.props.collectIdItemCurrent.length ? (
                                    <Pagination
                                        current={this.props.pagination.currentPage}
                                        total={this.props.pagination.countItemName}
                                        pageSize={this.props.pagination.pageSize}
                                        className='pagination-item-name'
                                        onChange={(current, size) => this.props.changePagination(current, size)}
                                        showLessItems
                                    />
                                ) : null}
                                <Select
                                    className="select-table-header-right"
                                    defaultValue={this.props.pagination.pageSize}
                                    value={this.props.pagination.pageSize}
                                    onChange={e => this.props.onChangePageSize(e)}>
                                    <Option value={10}>10</Option>
                                    <Option value={20}>20</Option>
                                    <Option value={50}>50</Option>
                                    <Option value={100}>100</Option>
                                </Select>
                                <span className="span-table-header-right">Per Page</span>
                            </div>
                        </Col>
                    </Row>

                </div>
                <div className="prohibited-options">
                    <Row gutter={6}>
                        <Col span={18}>
                            <div className="message-warning">Prohibited Item Keywords:
                                <a className={!this.props.keywordSearch ? "active-filter-prohibited prohibited-all" : "prohibited-all"}
                                    onClick={e => this.handleFilterProhibited('All')}>ALL({this.props.NumberProhibited})</a>
                                {this.renderProhibitedModel(this.props.ProhibitedModel)}
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="icon-checkbox">
                                <Checkbox className="button-checkbox" onChange={this.onChangeHasApprove} name="hasApprove">Include Ignored/Approved Items</Checkbox>
                            </div>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        );
    }
}

export default ToolbarItemProhibited




// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/prohibited-items/ToolbarItemProhibited.js